export * from './BackToTop';
//# sourceMappingURL=index.js.map